//
// These are the names of the service types
//
export const automatedShipmentStatusServiceType = 'Automated Shipment Statuses';
export const powerPlusServiceType = 'Power Plus';
export const hazmatServiceType = 'Hazmat Certified';
